import { ApiClient } from '../../../utils/apiClient';

// Neutral home for the campaign-generation alert badge endpoint/type, shared by
// the admin campaign-overview dashboard and the global nav so neither depends on
// the other's module layout.
export interface CampaignAlertBadgeData {
  count: number;
  subscribed: boolean;
}

export const CAMPAIGN_ALERT_BADGE_PATH = '/internal-api/campaign-overview/alert-badge';

interface CreateCampaignAlertBadgeApiParams {
  api: ApiClient;
}

export const createCampaignAlertBadgeApi = ({ api }: CreateCampaignAlertBadgeApiParams) => ({
  getAlertBadge: async (): Promise<CampaignAlertBadgeData> => api.get<CampaignAlertBadgeData>(CAMPAIGN_ALERT_BADGE_PATH),
});
